import React, { useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import { ReactComponent as SolarSystem } from './ecosystem1.svg'
import { ReactComponent as SolarSystemSmall } from './ecosystemSmall1.svg'

import Stars from './stars.svg'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const ContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  background: ${({ theme }) => theme.bg1}
  position: relative;

  height: 100%;
  width: 100%;

  padding: 16px;
  overflow: visible;

  position: relative;
  @keyframes glow {
    from {
      filter: drop-shadow(0 0 1px white);
      opacity: 0.1;
    }
    to {
      filter: drop-shadow(0 0 8px white);
       opacity: 1;
    }
  }
     @keyframes glow2 {
    from {
   filter: drop-shadow(0 0 8px white);
       opacity: 1;
    }
    to {
     
        filter: drop-shadow(0 0 1px white);
      opacity: 0.1;
    }
  }
  .stars {
    position: absolute;
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 0 6px white);
    animation: glow 4s ease-in-out infinite alternate;
  }

  .stars2 {
      transform: rotate(90deg);

     position: absolute;
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 0 6px white);
    animation: glow2 4s ease-in-out infinite alternate;
  }

   #ecosystem {
    width: 100%;
    height: 100%;
    animation: ${fadeIn} 0.3s ease-out;
    margin: 0 auto;
    overflow: visible;
    z-index: 1;
  }
    
  .line {
    animation: colorShift 20s ease-in-out infinite;
  }

  .logoFirst {
  }

  .logoThatMoves {
     transform-origin: center;
  }

  .lineWithLogo {
    transform-origin: center;
  }

  @keyframes colorShift {
    0%,
    100% {
      stroke: #00ffff;
    }
    50% {
      stroke: #6cfd56;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }

  ${[1, 2, 3, 4, 5, 6, 7, 8]
    .map(
      (i) => `
    .spin${i} {
      animation: spin ${i * 50}s linear infinite;
      transform-origin: center;
    }
  `
    )
    .join('\n')}

  ${[1, 2, 3, 4, 5, 6, 7, 8]
    .map(
      (i) => `
      .pulsing${i} {
        animation: pulse ${i * 5}s ease-in-out infinite;
        transform-origin: center;
        transform-box: fill-box;
      }
    `
    )
    .join('\n')}
`

const Ecosystem: React.FC<{ styles?: React.CSSProperties; small?: boolean }> = ({ styles, small = false }) => {
  useEffect(() => {
    const elements = document.getElementsByClassName('lineWithLogo')

    Array.from(elements).forEach((el) => {
      el.classList.add(`spin${Math.floor(Math.random() * (8 - 1) + 1)}`)
    })

    const logos = document.getElementsByClassName('logoThatMoves')
    Array.from(logos).forEach((el) => {
      el.classList.add(`pulsing${Math.floor(Math.random() * (8 - 1) + 1)}`)
    })
  }, [])

  return (
    <>
      <ContainerStyled style={styles}>
        <img src={Stars} className="stars" />
        <img src={Stars} className="stars2" />
        {small ? <SolarSystemSmall id="ecosystem" /> : <SolarSystem id="ecosystem" />}
      </ContainerStyled>
    </>
  )
}

export default Ecosystem
